const { getQueryVars } = require("./Util");

$('.js-search-open').on('click', function() {
    App.H.addClass('_search-open');
});

App.B.on('click', function(e){
    if (!$(e.target).parents().addBack().is('.search-line-wrapper') && !$(e.target).parents().addBack().is('.js-search-open')){
        App.H.removeClass('_search-open');
    }
});

(function() {

    if (!App.H.is('.page-search')) {
        return;
    }

    let $content;
    let $searchPageForm;
    let $searchPageFormInput;
    let $searchPageFormClear;
    let $searchPageFilter;
    let $searchPageFilterItem;
    let $pagination;
    
    function initSearch()
    {
        $content = $('.js-content');
        $searchPageForm = $('.js-search-page-form');
        $searchPageFormInput = $searchPageForm.find('.js-search-input');
        $searchPageFormClear = $searchPageForm.find('.js-search-clear');
        $searchPageFilter = $('.js-search-filter');
        $searchPageFilterItem = $searchPageFilter.find('.js-search-filter-item');
        $pagination = $('.pagination');
    
        $searchPageForm.on('submit', function(e, params) {
            e.preventDefault();
            submitSearchForm(params);
        });
        
        $searchPageFormClear.on('click', function() {
            $searchPageFormInput.val('');
        });
        
        $searchPageFilterItem.on('change', function() {
            $searchPageForm.trigger('submit');
        });
    
        $pagination.on('click', function (e) {
            let $target = $(e.target);
            if (!$target.is('a')) {
                return;
            }
            e.preventDefault();
            let href = $target.attr('href');
            let queryParams = getQueryVars(href);
            let params = queryParams.map(function (val, index, arr) {
                return {
                    'name': val,
                    'value': arr[val]
                };
            });
            $searchPageForm.trigger('submit', [params]);
        });
    }
    
    initSearch();
    
    function updateUrlParams(params) {
        if (window.history && params) {
            let url = window.location.pathname + '?' + params;
            window.history.replaceState({}, '', url);
        }
    }
    
    function submitSearchForm(params) {
        let formParams = $searchPageForm.serializeArray();
        if (Array.isArray(params)) {
            let  rawParams = formParams.concat(params);
            let uniqueQueryParams = {};
            rawParams.forEach(rawParam => {
                uniqueQueryParams[rawParam.name] = rawParam.value; 
            });
            formParams = [];
            for (const [key, value] of Object.entries(uniqueQueryParams)) {
                formParams.push({
                    'name': key,
                    'value': value
                });
            }
        }
        let serializedParams = $.param(formParams);
        updateUrlParams(serializedParams);
        $.ajax({
            url: $searchPageForm.attr('action'),
            method: $searchPageForm.attr('method') || 'GET',
            data: serializedParams,
            cache: false,
            success: (response) => {
                if (response.success && response.data) {
                    let $response_content = $(response.data);
                    $content.replaceWith($response_content);
                    initSearch();
                    $('html, body').animate({
                        scrollTop: 0
                    }, 800);
                }
            },
            error: () => {
                console.log('Ошибка получения данных фильтра');
            }
        });
    }    

})();


// WEBPACK FOOTER //
// ./_src/js/modules/Search.js